<div>
    <div class="form-group">
        <label>{{'USER.RESERVATIONS.SLOT.TABLE.slotTime' | translate}}</label>
        <select class="form-select form-select-sm" [(ngModel)]="slot" (change)="onSlotTimeChange()">
            <option [ngValue]="null">{{'USER.RESERVATIONS.SLOT.TABLE.closed' | translate}}</option>
            <option [ngValue]="30">30 {{'USER.RESERVATIONS.SLOT.TABLE.minutes' | translate}}</option>
            <option [ngValue]="60">60 {{'USER.RESERVATIONS.SLOT.TABLE.minutes' | translate}}</option>
            <option [ngValue]="90">90 {{'USER.RESERVATIONS.SLOT.TABLE.minutes' | translate}}</option>
            <option [ngValue]="120">120 {{'USER.RESERVATIONS.SLOT.TABLE.minutes' | translate}}</option>
        </select>
    </div>
    <div class="form-group">
        <label>{{'USER.RESERVATIONS.SLOT.TABLE.allowedPersons' | translate}}</label>
        <input type="number" class="form-control form-control-sm" [disabled]="slot == null"
            (change)="onAllowedPersonsChange()" [(ngModel)]="allowedPersons" />
    </div>
</div>